import { Event } from "../events/Event";
import { EventDispatcher } from "../events/EventDispatcher";
import { _WebSocket } from "../net/WebSocket";
import { Browser } from "../utils/Browser";
import { PAL } from "./PlatformAdapters";
export class BrowserAdapter extends EventDispatcher {
    constructor() {
        super();
        this.webSocketClass = _WebSocket;
        this._pixelRatio = 1;
        this.init();
        this.initRequestFrameFunction();
    }
    init() {
        var _a;
        let doc = Browser.document;
        let win = Browser.window;
        this._pixelRatio = Math.max(1, (win.devicePixelRatio || 1));
        this.setPlatform(win.navigator.userAgent || "", win.navigator.platform || "");
        let state = "visibilityState", visibilityChange = "visibilitychange";
        let fullscreenchange = "fullscreenchange";
        if (typeof doc.hidden !== "undefined") {
            visibilityChange = "visibilitychange";
            state = "visibilityState";
            fullscreenchange = "fullscreenchange";
        }
        else if (typeof doc.mozHidden !== "undefined") {
            visibilityChange = "mozvisibilitychange";
            state = "mozVisibilityState";
            fullscreenchange = "mozfullscreenchange";
        }
        else if (typeof doc.msHidden !== "undefined") {
            visibilityChange = "msvisibilitychange";
            state = "msVisibilityState";
            fullscreenchange = "msfullscreenchange";
        }
        else if (typeof doc.webkitHidden !== "undefined") {
            visibilityChange = "webkitvisibilitychange";
            state = "webkitVisibilityState";
            fullscreenchange = "webkitfullscreenchange";
        }
        this._visibilityStateKey = state;
        doc.addEventListener(visibilityChange, () => {
            this.event(Event.VISIBILITY_CHANGE, this.getVisibility());
            if (Browser.onAndroid && !Browser.onLayaRuntime) {
                if (this.getVisibility())
                    this.event(Event.FOCUS);
                else
                    this.event(Event.BLUR);
            }
        });
        doc.addEventListener(fullscreenchange, () => this.event(Event.FULL_SCREEN_CHANGE));
        win.addEventListener("resize", () => this.event(Event.RESIZE));
        win.addEventListener("orientationchange", (e) => this.event(Event.ORIENTATION_CHANGE, e));
        win.addEventListener("focus", () => this.event(Event.FOCUS));
        win.addEventListener("blur", () => this.event(Event.BLUR));
        if (Browser.onIOS && !Browser.onLayaRuntime) {
            let onUserInteraction = () => this.event(Event.FOCUS);
            win.addEventListener("touchstart", onUserInteraction, true);
            win.addEventListener("mousedown", onUserInteraction, true);
        }
        win.addEventListener("unhandledrejection", e => this.event("unhandledrejection", e));
        let bodyStyle = doc.body.style;
        bodyStyle.margin = 0;
        bodyStyle.overflow = 'hidden';
        bodyStyle['-webkit-user-select'] = 'none';
        bodyStyle['-webkit-tap-highlight-color'] = 'rgba(200,200,200,0)';
        let metas = doc.getElementsByTagName('meta');
        let viewportContent = {
            "width": "device-width",
            "initial-scale": "1.0",
            "minimum-scale": "1.0",
            "maximum-scale": "1.0",
            "user-scalable": "no"
        };
        let viewport;
        for (let i = 0; i < metas.length; i++) {
            let meta = metas[i];
            if (meta.name === "viewport") {
                viewport = meta;
                break;
            }
        }
        if (!viewport) {
            viewport = doc.createElement('meta');
            viewport.name = 'viewport';
            (_a = doc.getElementsByTagName('head')[0]) === null || _a === void 0 ? void 0 : _a.appendChild(viewport);
        }
        else {
            let arr = (viewport.content || "").split(",");
            for (let ele of arr) {
                let arr2 = ele.split("=");
                if (!viewportContent[arr2[0].trim()])
                    viewportContent[arr2[0]] = arr2[1];
            }
        }
        viewport.content = Object.keys(viewportContent).map(k => k + "=" + viewportContent[k]);
    }
    setPlatform(u, platform) {
        platform = platform.toLowerCase();
        Browser.userAgent = u;
        Browser.onMobile = u.indexOf("Mobile") > -1;
        Browser.onIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        Browser.onIPhone = u.indexOf("iPhone") > -1;
        Browser.onMac = u.indexOf("Mac OS X") > -1;
        Browser.onIPad = u.indexOf("iPad") > -1;
        Browser.onAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
        Browser.onOpenHarmonyOS = u.indexOf('OpenHarmony') > -1;
        Browser.onWP = u.indexOf("Windows Phone") > -1;
        Browser.onQQBrowser = u.indexOf("QQBrowser") > -1;
        Browser.onMQQBrowser = u.indexOf("MQQBrowser") > -1 || (u.indexOf("Mobile") > -1 && u.indexOf("QQ") > -1);
        Browser.onIE = !!window.ActiveXObject || "ActiveXObject" in window;
        Browser.onWeiXin = u.indexOf('MicroMessenger') > -1;
        Browser.onSafari = u.indexOf("Safari") > -1 && u.indexOf("Chrome") === -1;
        Browser.onChrome = u.indexOf("Chrome") > -1;
        Browser.onFirefox = u.indexOf('Firefox') > -1;
        Browser.onEdge = u.indexOf('Edge') > -1 || u.indexOf('Edg') > -1;
        if (platform.indexOf("ios") !== -1) {
            Browser.onIOS = true;
            Browser.onMobile = true;
            if (!u) {
                Browser.onIPhone = true;
                Browser.onIPad = true;
            }
            Browser.platform = Browser.PLATFORM_IOS;
            Browser.platformName = "ios";
        }
        else if (platform.indexOf("android") !== -1) {
            Browser.onAndroid = true;
            Browser.onMobile = true;
            Browser.platform = Browser.PLATFORM_ANDROID;
            Browser.platformName = "android";
        }
        else if (platform.indexOf("ohos") !== -1) {
            Browser.onOpenHarmonyOS = true;
            Browser.onMobile = true;
            Browser.platform = Browser.PLATFORM_ANDROID;
            Browser.platformName = "ohos";
        }
        else if (platform.indexOf("mac") !== -1) {
            Browser.onMac = true;
            Browser.platform = Browser.PLATFORM_PC;
            Browser.platformName = "mac";
        }
        else if (platform.indexOf("win") !== -1) {
            Browser.platform = Browser.PLATFORM_PC;
            Browser.platformName = "windows";
        }
        else if (Browser.onAndroid) {
            Browser.platform = Browser.PLATFORM_ANDROID;
            Browser.platformName = "android";
        }
        else if (Browser.onIOS) {
            Browser.platform = Browser.PLATFORM_IOS;
            Browser.platformName = "ios";
        }
        else {
            Browser.platform = Browser.PLATFORM_PC;
            Browser.platformName = platform;
        }
        Browser.onPC = !Browser.onMobile;
        Browser.onDevTools = Browser.platformName === "devtools";
        Browser.isTouchDevice = true;
        if (u.indexOf("Mozilla/6.0(Linux; Android 6.0; HUAWEI NXT-AL10 Build/HUAWEINXT-AL10)") != -1)
            this._pixelRatio = 2;
    }
    initRequestFrameFunction() {
        if (!window.requestAnimationFrame) {
            window.requestAnimationFrame = window.webkitRequestAnimationFrame
                || window.mozRequestAnimationFrame
                || window.oRequestAnimationFrame
                || window.msRequestAnimationFrame
                || function (fun) {
                    return setTimeout(fun, 1000 / 60);
                };
        }
    }
    start() {
        return Promise.resolve();
    }
    onInitRender() {
    }
    getScreenOrientation() {
        let ret = window.screen.orientation.type;
        if (ret == null) {
            let o = window.orientation;
            switch (o) {
                case 0:
                    ret = "portrait-primary";
                    break;
                case 180:
                    ret = "portrait-secondary";
                    break;
                case 90:
                    ret = "landscape-primary";
                    break;
                case -90:
                    ret = "landscape-secondary";
                    break;
            }
        }
        return ret;
    }
    getPixelRatio() {
        return this._pixelRatio;
    }
    getClientWidth() {
        return Browser.window.innerWidth || Browser.document.body.clientWidth || Browser.document.documentElement.clientWidth;
    }
    getClientHeight() {
        return Browser.window.innerHeight || Browser.document.body.clientHeight || Browser.document.documentElement.clientHeight;
    }
    getVisibility() {
        return Browser.document[this._visibilityStateKey] !== "hidden";
    }
    requestFullscreen() {
        let ele = Browser.document.documentElement;
        if (!ele)
            return;
        if (ele.requestFullscreen)
            ele.requestFullscreen();
        else if (ele.mozRequestFullScreen)
            ele.mozRequestFullScreen();
        else if (ele.webkitRequestFullscreen)
            ele.webkitRequestFullscreen();
        else if (ele.msRequestFullscreen)
            ele.msRequestFullscreen();
    }
    exitFullscreen() {
        let doc = document;
        if (doc.exitFullscreen)
            doc.exitFullscreen();
        else if (doc.mozCancelFullScreen)
            doc.mozCancelFullScreen();
        else if (doc.webkitExitFullscreen)
            doc.webkitExitFullscreen();
    }
    createElement(tagName) {
        return Browser.document.createElement(tagName);
    }
    getElementById(id) {
        return Browser.document.getElementById(id);
    }
    removeElement(ele) {
        ele && ele.remove();
    }
    createMainCanvas() {
        let canvas = this.createElement("canvas");
        canvas.id = "layaCanvas";
        canvas.width = 2;
        canvas.height = 2;
        let style = canvas.style;
        style.position = 'absolute';
        style.top = style.left = "0px";
        style.background = "#000000";
        let container = Browser.document.createElement("div");
        container.id = "layaContainer";
        Browser.document.body.appendChild(container);
        container.appendChild(canvas);
        return canvas;
    }
    setCursor(cursor) {
        if (Browser.isDomSupported)
            Browser.document.body.style.cursor = cursor;
    }
    get supportArrayBufferURL() {
        return !!window.Blob;
    }
    createBufferURL(data) {
        if (window.Blob) {
            let blob = new Blob([data], { type: 'application/octet-binary' });
            return window.URL.createObjectURL(blob);
        }
        else
            return null;
    }
    revokeBufferURL(url) {
        window.URL.revokeObjectURL(url);
    }
    getOpenDataContextCanvas() {
        return null;
    }
    postMessageToOpenDataContext(msg) {
    }
    captureGlobalError(callback) {
        this._globalErrorCallback = callback;
        this.onCaptureGlobalError(callback != null, onError);
    }
    onCaptureGlobalError(enabled, func) {
        if (enabled) {
            Browser.window.addEventListener("error", func);
            Browser.window.addEventListener("unhandledrejection", func);
        }
        else {
            Browser.window.removeEventListener("error", func);
            Browser.window.removeEventListener("unhandledrejection", func);
        }
    }
    alert(msg) {
        Browser.window.alert(msg);
    }
    setStyleTransformOrigin(style, value) {
        style.transformOrigin = style.webkitTransformOrigin
            = style.msTransformOrigin = style.mozTransformOrigin
                = style.oTransformOrigin = value;
    }
    setStyleTransform(style, value) {
        style.transform = style.webkitTransform
            = style.msTransform = style.mozTransform
                = style.oTransform = value;
    }
    createWebSocket() {
        if (this.webSocketClass)
            return new this.webSocketClass();
        else
            return null;
    }
}
function onError(e) {
    PAL.browser._globalErrorCallback(e);
}
PAL.register("browser", BrowserAdapter);
